(function () {
  'use strict';
  const LANGUAGES = ['fr', 'en', 'it', 'nl', 'pt-PT', 'de', 'es', 'br', 'wo', 'ln', 'cr', 'cr-signature', 'ndjuka', 'saramaka'];
  function orderSelection(models, preset, language, messages, origineMessages) {
    const model = models.find(m => m.preset === preset);
    if (model?.origineLanguage && model.origineLanguage !== language) return null;
    if (!model?.origineLanguage && ['cr', 'ndjuka', 'saramaka'].includes(language)) return null;
    if (['wo', 'ln', 'cr-signature'].includes(language) && !['mia', 'noah'].includes(model?.characterId)) return null;
    const text = model?.origineLanguage ? origineMessages?.[language] : (language === 'it' && model?.audience === 'girl' ? { ...messages?.[language], top: 'BIMBA A BORDO' } : messages?.[language]);
    if (!model || !LANGUAGES.includes(language) || !text || !text.top || !text.bottom) return null;
    return {name:model.name, preset:model.preset, language:language === 'cr-signature' ? 'cr' : language, top:text.top, bottom:text.bottom};
  }
  function variantForOrder(variants, order, fade) {
    const matches = order && Array.isArray(variants) ? variants.filter(v => v.sku === ['eclat', order.preset, order.language, fade].join('|')) : [];
    return matches.length === 1 && Number.isSafeInteger(matches[0].price) && matches[0].price > 0 && matches[0].available && matches[0].image ? matches[0] : null;
  }
  function initialize(root) {
    const form = root.querySelector('[data-eclat-purchase]');
    if (!form || form.dataset.eclatPurchaseReady) return;
    const buy = form.querySelector('[data-eclat-buy]');
    const languages = root.querySelector('[data-eclat-language]');
    const buttons = Array.from(root.querySelectorAll('[data-eclat-model]'));
    let config;
    try { config = JSON.parse(root.querySelector('[data-eclat-config]').textContent); } catch (_) { return; }
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-eclat-order-variants]').textContent); } catch (_) { return; }
    const models = buttons.map(b => ({name:b.dataset.eclatName,preset:b.dataset.eclatPreset,characterId:b.dataset.eclatCharacter,origineLanguage:b.dataset.eclatOrigineLanguage,audience:b.dataset.eclatAudience}));
    function sync() {
      const selected = buttons.filter(b => b.getAttribute('aria-pressed') === 'true');
      const order = selected.length === 1 && root.dataset.eclatInitialized === 'true'
        ? orderSelection(models, selected[0].dataset.eclatPreset, languages.value, config.languages, config.origineMessages) : null;
      const fade = root.dataset.eclatFadeEnabled === 'true' ? 'on' : 'off';
      const variant = variantForOrder(variants, order, fade);
      buy.disabled = !order || !variant || form.dataset.eclatAvailable !== 'true';
      form.querySelector('[name="id"]').value = variant ? variant.id : '';
      if (!order || !variant) return false;
      const price = root.querySelector('[data-eclat-price]');
      if (price) price.textContent = new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency || 'EUR', currencyDisplay:'narrowSymbol'}).format(variant.price / 100);
      for (const key of ['name', 'preset', 'language', 'top', 'bottom']) form.querySelector('[data-eclat-order-'+key+']').value = order[key];
      form.querySelector('[data-eclat-order-fade]').value = fade;
      return form.dataset.eclatAvailable === 'true';
    }
    root.addEventListener('click', sync);
    languages.addEventListener('change', sync);
    root.querySelector('[data-eclat-fade]')?.addEventListener('change', sync);
    form.addEventListener('submit', event => { if (!sync()) event.preventDefault(); });
    sync();
    form.dataset.eclatPurchaseReady = 'true';
  }
  function boot(scope) { scope.querySelectorAll('[data-clairabord-eclat]').forEach(initialize); }
  if (typeof module !== 'undefined' && module.exports) module.exports = {orderSelection, variantForOrder};
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);
    document.addEventListener('shopify:section:load', event => boot(event.target));
  }
})();
